import { render, staticRenderFns } from "./HomePadrao.vue?vue&type=template&id=0bbf420c&%40click.stop=dialog%20%3D%20false"
import script from "./HomePadrao.vue?vue&type=script&lang=js"
export * from "./HomePadrao.vue?vue&type=script&lang=js"
import style0 from "./HomePadrao.vue?vue&type=style&index=0&id=0bbf420c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports